import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_UPDATE_FUNDS_PROMO_CODE = createRequestTypes(
  'script-helpers/UPDATE_FUNDS_PROMO_CODE',
);
